<script lang="ts" setup>
import {
  ChevronDownIcon,
  ChevronUpIcon,
  Copy04Icon,
} from '@gohighlevel/ghl-icons/24/outline'
import { UIButton } from '@gohighlevel/ghl-ui'
import { useI18n } from 'vue-i18n'
import { copyToClipboard } from '../../utils/generalFunctions'
import { useNotify } from '../composition/notification'
const { t } = useI18n()
const { sendNotification } = useNotify()

defineProps({
  header: String,
  description: String,
  showIcon: Boolean,
  isExpanded: Boolean,
  showCalendarId: Boolean,
  calendarId: String,
})

const copyCalendarId = id => {
  copyToClipboard(id)
  sendNotification({
    type: 'info',
    title: t('settings.calendar.copied_to_clipboard'),
    icon: 'InfoCircleIcon',
    duration: 1000,
  })
}
</script>

<template>
  <div
    class="flex w-full flex-row items-end justify-between gap-8 transition-all"
  >
    <div>
      <div class="text-[16px] font-normal text-gray-900">
        {{ header }}
      </div>
      <div class="text-[14px] font-normal leading-6 text-gray-500">
        {{ description }}
      </div>
    </div>
    <div
      class="text-[14px] font-normal text-gray-500"
      v-if="showCalendarId && calendarId"
    >
      <UIButton
        id=""
        class="w-3/4 cursor-pointer text-gray-500"
        :text="true"
        @click="copyCalendarId(calendarId)"
      >
        <div class="flex flex-row items-center gap-2">
          {{ $t('labels.calendar_id') }}: {{ calendarId }}
          <Copy04Icon class="h-4 w-4" />
        </div>
      </UIButton>
    </div>
    <div v-if="showIcon">
      <ChevronUpIcon
        class="h-5 w-5 font-semibold text-gray-700"
        v-if="isExpanded"
      />
      <ChevronDownIcon class="h-5 w-5 text-gray-700" v-else />
    </div>
  </div>
</template>
